import { combineReducers } from 'redux'
import { calendarsReducer, systemReducer, userReducer, suppliersReducer } from 'redux/reducers'

const rootReducer = combineReducers({
    system: systemReducer,
    user: userReducer,
    calendars: calendarsReducer,
    suppliers: suppliersReducer
})

export default rootReducer
